export default "__VITE_ASSET__CxfWeqfj__"